import { defineStore } from "pinia"
import { reactive } from "vue"
import { api } from "@/plugins/api"

export const useNoticesStore = defineStore("notices", () => {
  const notices: any[] = reactive([])

  const fetchNotices = async () => {
    const {data} = await api.page.getPages({
      status: "PUBLISHED",
      type: "notice"
    })
    notices.splice(0, notices.length)
    notices.push(...(data.data.items || []))
  }

  return {
    notices,
    fetchNotices
  }
})